import { Redirect } from 'expo-router';

import { WebLanding } from '@/components/domain/webLanding/WebLanding';
import { useAuth } from '@/lib/auth';

export default function LandingScreen() {
  const { session, status } = useAuth();

  if (status === 'ready' && session) return <Redirect href="/" />;

  return <WebLanding />;
}
